export default __webpack_public_path__ + "static/media/element_6.8d381c2b.jpg";